@if (!isDasboard) {
  <app-table-header
    (reload)="onRefreshList(false)"
    [loading]="loading"
    [withExportOption]="!!data.info.exportTableName"
    (exportBtnClicked)="exportBtnClicked()"
    >
    <app-download-documents [documentKeys]="selectedDocumentKeys"></app-download-documents>
    <div class="uncompleted-orders-checkbox-wrapper">
      <label
        nz-checkbox
        [(ngModel)]="showUncompletedOrders"
        (ngModelChange)="valueChanged()"
      >Offene Produktionsaufträge</label>
    </div>
    <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
  </app-table-header>
}
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzScroll]="{ x: tableMaxWidth }"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzShowPagination]="!isDasboard"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="production-orders-list-table"
  nzSize="small"
  >
  <thead>
    <tr>
      @if (!isDasboard) {
        <th data-col-key="selection"
          [(nzChecked)]="checked"
          [nzIndeterminate]="indeterminate"
          (nzCheckedChange)="onAllChecked($event)"
          nzWidth="60px"
        ></th>
      }
      @if (!isDasboard) {
        <th nzColumnKey="id" [nzShowSort]="!isDasboard" [nzSortFn]="true" nzSortOrder="descend">ID</th>
      }
      <th nzColumnKey="createdAt" [nzShowSort]="!isDasboard" [nzSortFn]="true">Datum</th>
      <th nzColumnKey="isPriority" [nzShowSort]="!isDasboard" [nzSortFn]="true">Priorität</th>
      <th nzColumnKey="article.orderNumber" [nzShowSort]="!isDasboard" [nzSortFn]="true">Artikelnummer</th>
      <th nzColumnKey="article.name" [nzShowSort]="!isDasboard" [nzSortFn]="true">Name</th>
      <th nzColumnKey="processingDate" [nzShowSort]="!isDasboard" [nzSortFn]="true" [nzSortOrder]="isDasboard ? 'descend' : null">Bearbeitungsdatum</th>
      <th nzColumnKey="worker.fullName" [nzShowSort]="!isDasboard" [nzSortFn]="true">Bearbeiter</th>
      @if (!isDasboard) {
        <th
          nzColumnKey="status"
          [nzFilters]="isDasboard ? [] : statusFilters"
          [nzFilterMultiple]="true"
          [nzFilterFn]="true"
          [nzShowSort]="!isDasboard"
          [nzSortFn]="true"
          (nzFilterChange)="filtersChanged()"
        >Status</th>
      }
      <th nzColumnKey="actions" nzRight nzWidth="100px"></th>
    </tr>
  </thead>
  <tbody>
    @for (pOrder of data.results; track pOrder) {
      <tr>
        @if (!isDasboard) {
          <td [nzChecked]="setOfCheckedId.has(pOrder.id)" (nzCheckedChange)="onItemChecked(pOrder.id, $event)"></td>
        }
        @if (!isDasboard) {
          <td>{{pOrder.id}}</td>
        }
        <td>{{pOrder.createdAt|dateFormat}}</td>
        <td nzAlign="center"><app-boolean-icon [state]="pOrder.isPriority"></app-boolean-icon></td>
        <td>{{pOrder.article.orderNumber}}</td>
        <td>{{pOrder.article.name}}</td>
        <td>{{pOrder.processingDate|dateFormat}}</td>
        <td>
          @for (worker of pOrder.workers; track worker) {
            {{ worker.fullName }}<br>
          }
        </td>
        @if (!isDasboard) {
          <td>{{pOrder.status | statusFormat}}</td>
        }
        <td nzRight>
          <div class="actions">
            <app-add-edit-modal (refresh)="onRefreshList(false)" #modal>
              <span trigger>
                <app-icon-button
                  icon="edit"
                  [ariaLabel]="'Produktionsauftrag bearbeiten: ' + pOrder.id"
                  (pressed)="modal.showModal(pOrder)"
                ></app-icon-button>
              </span>
            </app-add-edit-modal>
            @if (pOrder.documentKey && pOrder.documentKey !== '') {
              <app-download-document [documentKey]="pOrder.documentKey"></app-download-document>
            }
            @if (pOrder.status !== 'Canceled') {
              <app-icon-button
                icon="stop"
                [ariaLabel]="'Produktionsauftrag stornieren: ' + pOrder.id"
                confirmTitle="Bestätigen Sie, dass Sie einen Produktionsauftrag stornieren möchten, wenn dieser im Voraus gebucht wurde, wird der Bestand reduziert."
                (confirmed)="cancelProductionOrder(pOrder.id)"
              ></app-icon-button>
            }
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>

@if (!isDasboard) {
  <app-export-table-modal #exportTableModalComponent></app-export-table-modal>
}
